// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/route_theme.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/route_theme.proto.
 */
export const file_travplaces_v1_route_theme: GenFile = /*@__PURE__*/
  fileDesc("Ch90cmF2cGxhY2VzL3YxL3JvdXRlX3RoZW1lLnByb3RvEg10cmF2cGxhY2VzLnYxIrIFCgpSb3V0ZVRoZW1lEgoKAmlkGAEgASgJEgsKA2tleRgCIAEoCRINCgVsYWJlbBgDIAEoCRITCgtkZXNjcmlwdGlvbhgEIAEoCRIVCg1jYXRlZ29yeV9rZXlzGAUgAygJEhsKE2F2b2lkX2NhdGVnb3J5X2tleXMYBiADKAkSGwoTYm9vc3RfY2F0ZWdvcnlfa2V5cxgHIAMoCRIdChBhdm9pZF9kaXN0YW5jZV9tGAggASgFSACIAQESEQoJbWluX3NoYXJlGAkgASgBEhEKCWlzX2FjdGl2ZRgKIAEoCBISCgpzb3J0X29yZGVyGAsgASgFEkYKD3JvdXRpbmdfb3B0aW9ucxgMIAMoCzItLnRyYXZwbGFjZXMudjEuUm91dGVUaGVtZS5Sb3V0aW5nT3B0aW9uc0VudHJ5ElIKFXJvdXRlX2NoYXJhY3RlcmlzdGljcxgNIAMoCzIzLnRyYXZwbGFjZXMudjEuUm91dGVUaGVtZS5Sb3V0ZUNoYXJhY3RlcmlzdGljc0VudHJ5EkAKDHBhdGhfb3B0aW9ucxgOIAMoCzIqLnRyYXZwbGFjZXMudjEuUm91dGVUaGVtZS5QYXRoT3B0aW9uc0VudHJ5EhUKCHNob3J0ZXN0GA8gASgISAGIAQEaNQoTUm91dGluZ09wdGlvbnNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAE6AjgBGjsKGVJvdXRlQ2hhcmFjdGVyaXN0aWNzRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgBOgI4ARoyChBQYXRoT3B0aW9uc0VudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoAToCOAFCEwoRX2F2b2lkX2Rpc3RhbmNlX21CCwoJX3Nob3J0ZXN0IhgKFkxpc3RSb3V0ZVRoZW1lc1JlcXVlc3QiRAoXTGlzdFJvdXRlVGhlbWVzUmVzcG9uc2USKQoGdGhlbWVzGAEgAygLMhkudHJhdnBsYWNlcy52MS5Sb3V0ZVRoZW1lMoIBChFSb3V0ZVRoZW1lU2VydmljZRJtCg9MaXN0Um91dGVUaGVtZXMSJS50cmF2cGxhY2VzLnYxLkxpc3RSb3V0ZVRoZW1lc1JlcXVlc3QaJi50cmF2cGxhY2VzLnYxLkxpc3RSb3V0ZVRoZW1lc1Jlc3BvbnNlIguK6jADCgEKkOowAUKqAQoRY29tLnRyYXZwbGFjZXMudjFCD1JvdXRlVGhlbWVQcm90b1ABWi90cmF2cGxhY2VzL2dlbi9wcm90by90cmF2cGxhY2VzL3YxO3RyYXZwbGFjZXN2MaICA1RYWKoCDVRyYXZwbGFjZXMuVjHKAg1UcmF2cGxhY2VzXFYx4gIZVHJhdnBsYWNlc1xWMVxHUEJNZXRhZGF0YeoCDlRyYXZwbGFjZXM6OlYxYgZwcm90bzM", [file_travplaces_v1_audit, file_travplaces_v1_authz]);

/**
 * RouteTheme is a route style with a promise attached: at least `min_share`
 * of the non-anchor stops come from its categories, so three themes offered
 * side by side are three recognisably different days out.
 *
 * @generated from message travplaces.v1.RouteTheme
 */
export type RouteTheme = Message<"travplaces.v1.RouteTheme"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * The categories that define the theme.
   *
   * @generated from field: repeated string category_keys = 5;
   */
  categoryKeys: string[];

  /**
   * Categories this theme keeps the route clear of, added to the request's.
   *
   * @generated from field: repeated string avoid_category_keys = 6;
   */
  avoidCategoryKeys: string[];

  /**
   * Categories ranked higher when the shortlist is scored, without a promised share.
   *
   * @generated from field: repeated string boost_category_keys = 7;
   */
  boostCategoryKeys: string[];

  /**
   * How far to hold from what it excludes. Unset falls through to the category.
   *
   * @generated from field: optional int32 avoid_distance_m = 8;
   */
  avoidDistanceM?: number | undefined;

  /**
   * The promise: this fraction of non-anchor stops comes from the categories.
   *
   * @generated from field: double min_share = 9;
   */
  minShare: number;

  /**
   * @generated from field: bool is_active = 10;
   */
  isActive: boolean;

  /**
   * @generated from field: int32 sort_order = 11;
   */
  sortOrder: number;

  /**
   *
   * What the emphasis says about the road and the journey.
   *
   * Carried on the wire so the planner can SHOW it. These were applied only
   * on the server before, which left the one screen that could say what an
   * emphasis would do saying nothing, and every field reading "Auto" while
   * the emphasis quietly answered it. Values are the same ones the request
   * carries, and the request still wins where both speak.
   *
   * @generated from field: map<string, double> routing_options = 12;
   */
  routingOptions: { [key: string]: number };

  /**
   * @generated from field: map<string, double> route_characteristics = 13;
   */
  routeCharacteristics: { [key: string]: number };

  /**
   * @generated from field: map<string, double> path_options = 14;
   */
  pathOptions: { [key: string]: number };

  /**
   * `shortest` is the one road answer that is a switch rather than a weight.
   *
   * @generated from field: optional bool shortest = 15;
   */
  shortest?: boolean | undefined;
};

/**
 * Describes the message travplaces.v1.RouteTheme.
 * Use `create(RouteThemeSchema)` to create a new message.
 */
export const RouteThemeSchema: GenMessage<RouteTheme> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_route_theme, 0);

/**
 * @generated from message travplaces.v1.ListRouteThemesRequest
 */
export type ListRouteThemesRequest = Message<"travplaces.v1.ListRouteThemesRequest"> & {
};

/**
 * Describes the message travplaces.v1.ListRouteThemesRequest.
 * Use `create(ListRouteThemesRequestSchema)` to create a new message.
 */
export const ListRouteThemesRequestSchema: GenMessage<ListRouteThemesRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_route_theme, 1);

/**
 * @generated from message travplaces.v1.ListRouteThemesResponse
 */
export type ListRouteThemesResponse = Message<"travplaces.v1.ListRouteThemesResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.RouteTheme themes = 1;
   */
  themes: RouteTheme[];
};

/**
 * Describes the message travplaces.v1.ListRouteThemesResponse.
 * Use `create(ListRouteThemesResponseSchema)` to create a new message.
 */
export const ListRouteThemesResponseSchema: GenMessage<ListRouteThemesResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_route_theme, 2);

/**
 * RouteThemeService serves the themed-alternative catalogue.
 *
 * @generated from service travplaces.v1.RouteThemeService
 */
export const RouteThemeService: GenService<{
  /**
   * ListRouteThemes returns the active themes, in display order.
   *
   * @generated from rpc travplaces.v1.RouteThemeService.ListRouteThemes
   */
  listRouteThemes: {
    methodKind: "unary";
    input: typeof ListRouteThemesRequestSchema;
    output: typeof ListRouteThemesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_route_theme, 0);

